import { render, staticRenderFns } from "./StoreClosureLabel.vue?vue&type=template&id=272ed0de&scoped=true&"
import script from "./StoreClosureLabel.vue?vue&type=script&lang=ts&"
export * from "./StoreClosureLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272ed0de",
  null
  
)

export default component.exports